import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X, ScrollText } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/", label: "Home" },
  { to: "/will-generator", label: "Will Generator" },
  { to: "/pricing", label: "Pricing" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className="sticky top-0 z-40 border-b border-[#0A1128]/10 bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/75"
      data-testid="main-navbar"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-navy text-gold">
            <ScrollText size={18} />
          </span>
          <div className="leading-tight">
            <div className="font-serif text-xl font-semibold text-navy">WillSeva</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-[#4A5568]">Legacy. Protected.</div>
          </div>
        </Link>

        <nav className="hidden items-center gap-7 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-navy" : "text-[#4A5568] hover:text-navy"
                }`
              }
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link to="/will-generator" className="hidden md:inline-flex">
            <Button
              className="bg-navy text-white hover:bg-[#1A2642]"
              data-testid="navbar-create-will-cta"
            >
              Create My Will – ₹99
            </Button>
          </Link>
          <button
            className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-[#0A1128]/15 text-navy md:hidden"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="navbar-mobile-toggle"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-[#0A1128]/10 bg-white md:hidden" data-testid="navbar-mobile-menu">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-5 py-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium ${
                    isActive ? "bg-[#F9FAFB] text-navy" : "text-[#4A5568]"
                  }`
                }
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/will-generator" className="mt-2">
              <Button
                className="w-full bg-navy text-white hover:bg-[#1A2642]"
                data-testid="navbar-mobile-create-will"
              >
                Create My Will – ₹99
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
